import { useEffect, useState } from "react";
import { supabase } from "@/src/integrations/supabase/client";

export function useBlogEnabled() {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from("blog_settings")
      .select("enabled")
      .eq("id", 1)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setEnabled(data?.enabled ?? true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
